import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import DataTableSearch from "../Common/HelpCommon/DataTableSearch";
import DataTablePagination from "../Common/HelpCommon/DataTablePagination";
import axios from "axios";
import "../App.css";
// import { io } from "socket.io-client";

var lActiveInputFeild = "";
const API_URL = process.env.REACT_APP_API;

// const socketURL = process.env.REACT_APP_API_URL;


const CarryAuctionHelp = ({ onAcCodeClick, name, AwakNo, OnAwakHead, OnAwakDetail, disabledFeild, tabIndexHelp, Type, excludeIds = [] }) => {

    const CompanyCode = sessionStorage.getItem("Company_Code")
    const Year_Code = sessionStorage.getItem("Year_Code");

    const [showModal, setShowModal] = useState(false);
    const [popupContent, setPopupContent] = useState([]);
    const [enteredAcCode, setEnteredAcCode] = useState("");
    const [type, setType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
    const [apiDataFetched, setApiDataFetched] = useState(false);

    // const fetchAndOpenPopup = async () => {
    //     try {
    //         const response = await axios.get(`${API_URL}/getdata-ForLockSauda?Company_Code=${CompanyCode}&Year_Code=${Year_Code}`);
    //         const data = response.data.all_data || [];
    //         const filteredData = data.filter(item =>
    //             (item.Ac_Name_E ? item.Ac_Name_E.toLowerCase().includes(searchTerm.toLowerCase()) : false)
    //             // (item.city_name_e ? item.city_name_e.toLowerCase().includes(searchTerm.toLowerCase()) : false)
    //         );
    //         setPopupContent(filteredData);
    //         setShowModal(true);
    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //     }
    // };

    const fetchAndOpenPopup = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/getdata-ForLockSauda?Company_Code=${CompanyCode}&Year_Code=${Year_Code}`
            );

            let data = response.data.all_data || [];

            //  REMOVE LOCKED RECORDS
            data = data.filter(item => item.AuctionMark !== "Y");

            //  REMOVE ALREADY SELECTED RECORDS
            if (excludeIds.length > 0) {
                data = data.filter(item => !excludeIds.includes(item.AwakDetailId));
            }

            setPopupContent(data);
            setShowModal(true);

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // useEffect(() => {
    //     // const socket = io("wss://accounts-backend.ebuysugar.com", { transports: ["websocket"] });
    //     const socket = io(`${socketURL}`, { transports: ["websocket"] });
    //     socket.on("connect", () => console.log("Socket connected:", socket.id));
    //     socket.on("getAll_awaks", (data) => console.log("Connected to server:"));
    //     socket.on("awak_added", fetchAndOpenPopup);
    //     socket.on("awak_updated", fetchAndOpenPopup);
    //     fetchAndOpenPopup();
    //     return () => socket.disconnect();
    // }, []);


    useEffect(() => {
        setEnteredAcCode(AwakNo);
        setType(Type);
    }, [AwakNo, Type]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchAndOpenPopup();
                setShowModal(false);
                setApiDataFetched(true);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        if (!apiDataFetched) {
            fetchData();
        }
    }, [apiDataFetched]);

    // Handle Mill Code button click
    const handleMillCodeButtonClick = () => {
        lActiveInputFeild = name
        fetchAndOpenPopup();
        // if (onAcCodeClick) {
        //     onAcCodeClick({ enteredAcCode });
        // }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleAcCodeChange = async (event) => {
        const { value } = event.target;
        setEnteredAcCode(value);
        try {
            const response = await axios.get(`${API_URL}/getdata-ForLockSauda?Company_Code=${CompanyCode}&Year_Code=${Year_Code}`);
            const data = response.data.all_data || [];
            setPopupContent(data);
            setApiDataFetched(true);
            const matchingItem = data.find((item) => item.Doc_No === parseInt(value, 10));
            if (matchingItem) {

                setEnteredAcCode(matchingItem.Doc_No);
                // setType(matchingItem.Tran_Type)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchSaleBillData = async (AwakNo) => {
        try {
            const response = await axios.get(`${API_URL}/AwakBy_doc_no?Company_Code=${CompanyCode}&Year_Code=${Year_Code}&Doc_No=${AwakNo}`);
            const saleBillHead = response.data.last_head_data;
            const saleBillDetail = response.data.last_details_data[0];
            OnAwakHead(saleBillHead)
            OnAwakDetail(saleBillDetail)
        } catch (error) {
            console.error("Error fetching SaleBill data:", error);
        }
    };

    const handleRecordDoubleClick = (item) => {
        if (lActiveInputFeild === name) {
            setEnteredAcCode(item.Doc_No);
            // setType(item.Tran_Type)
            fetchSaleBillData(item.Doc_No);
            if (onAcCodeClick) {
                onAcCodeClick(item);
            }
        }
        setShowModal(false);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleSearch = (searchValue) => {
        setSearchTerm(searchValue);
    };

    const filteredData = popupContent.filter((item) => {
        const search = searchTerm.toLowerCase().trim();

        return (
            (item.Doc_No && item.Doc_No.toString().includes(search)) ||
            (item.Ac_Name_E && item.Ac_Name_E.toLowerCase().includes(search))
        );
    });

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const itemsToDisplay = filteredData.slice(startIndex, endIndex);

    useEffect(() => {
        if (AwakNo === "") {
            setEnteredAcCode("");
        } else {
            setEnteredAcCode(AwakNo);
        }
    }, [AwakNo]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "F1") {
                if (event.target.id === name) {
                    lActiveInputFeild = name;
                    setSearchTerm(event.target.value);
                    fetchAndOpenPopup();
                    event.preventDefault();
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [name, fetchAndOpenPopup]);

    useEffect(() => {
        const handleKeyNavigation = (event) => {
            if (showModal) {
                if (event.key === "ArrowUp") {
                    event.preventDefault();
                    setSelectedRowIndex((prev) => Math.max(prev - 1, 0));
                } else if (event.key === "ArrowDown") {
                    event.preventDefault();
                    setSelectedRowIndex((prev) => Math.min(prev + 1, itemsToDisplay.length - 1));
                } else if (event.key === "Enter") {
                    event.preventDefault();
                    if (selectedRowIndex >= 0) {
                        handleRecordDoubleClick(itemsToDisplay[selectedRowIndex]);
                    }
                }
            }
        };

        window.addEventListener("keydown", handleKeyNavigation);
        return () => {
            window.removeEventListener("keydown", handleKeyNavigation);
        };
    }, [showModal, selectedRowIndex, itemsToDisplay, handleRecordDoubleClick]);

    return (
        <div className="d-flex flex-row ">
            <div className="d-flex ">
                <div className="d-flex">
                    <input

                        type="text"
                        className="form-control ms-2"
                        id={name}
                        autoComplete="off"
                        value={enteredAcCode}
                        onChange={handleAcCodeChange}
                        style={{ width: "100px", height: "35px" }}
                        disabled={disabledFeild}
                        tabIndex={tabIndexHelp}
                    />
                    <Button

                        variant="primary"
                        onClick={handleMillCodeButtonClick}
                        className="ms-1"
                        style={{ width: "30px", height: "35px" }}
                        disabled={disabledFeild}
                        tabIndex={tabIndexHelp}
                    >
                        ...
                    </Button>
                    <label id="name" className="form-labels ms-2" style={{ whiteSpace: 'nowrap', fontSize: "14px", fontWeight: "bold", marginTop: "5px" }}>
                        {type !== '' ? type : Type}
                    </label>
                </div>
            </div>
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="modal-dialog"
            >
                <Modal.Header style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Modal.Title>Carry For Auction Help</Modal.Title>
                    <Button
                        style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: 'blue', position: 'absolute', right: '10px' }}
                        onClick={handleCloseModal}
                    >
                        X
                    </Button>
                </Modal.Header>
                <DataTableSearch data={popupContent} onSearch={handleSearch} />
                <Modal.Body>
                    {Array.isArray(popupContent) ? (
                        <div style={{ overflowX: "auto" }}>
                            <table style={{
                                width: "150%",
                                borderCollapse: "collapse",
                                marginBottom: "1rem",
                                backgroundColor: "#fff",
                            }}>
                                <thead style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Awak No</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Date</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Farmer Code</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Farmer Name</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>City</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Qty</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Item Name</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Godown Name</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Line Name</th>
                                        <th style={{ border: "1px solid #dee2e6", padding: "8px", whiteSpace: "nowrap" }}>Balance</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {itemsToDisplay.map((item, index) => (
                                        <tr
                                            key={index}
                                            className={
                                                selectedRowIndex === index ? "selected-row" : ""
                                            }
                                            onDoubleClick={() => handleRecordDoubleClick(item)}
                                        >
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Doc_No}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Doc_Date}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Ac_code}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Ac_Name_E}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.city_name_e}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Awak_Qty}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Item}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Godown}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.Line}</td>
                                            <td style={{ border: "1px solid #dee2e6", padding: "8px" }}>{item.balance}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        "Loading..."
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <DataTablePagination
                        totalItems={filteredData.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={handlePageChange}
                    />
                    {/* <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button> */}
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CarryAuctionHelp;